import { useTranslation } from "react-i18next";
import { useTime } from "../../context/TimeContext";
import { formatCurrentDay, formatCurrentTime } from "../../utils/formatting/formatCurrentDate";
import { StyledDate, DateContainer } from "./styled";
import { useLocation } from "react-router-dom";

export const CurrentDate = ({ authRoutes }: { authRoutes: string[] }) => {
  const { now: currentDate } = useTime();
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation("translation", {
    keyPrefix: "currentDate",
  });

  const authRoute = authRoutes.includes(pathname);
  if (authRoute) return null;

  return (
    <DateContainer>
      <StyledDate $comentary>
        {t("description")}
        {formatCurrentDay(currentDate, i18n.language)},
      </StyledDate>
      <StyledDate>{formatCurrentTime(currentDate, i18n.language)}</StyledDate>
    </DateContainer>
  );
};
